/** Batch profile lookups; never interpret a failed lookup as a missing nickname. */
export async function loadProfileNicknames(client, userIds) {
  const ids = [...new Set(userIds.filter((id) => Number.isSafeInteger(id) && id > 0))];
  const names = new Map();
  for (let offset = 0; offset < ids.length; offset += 200) {
    const { data, error } = await client.from('common_profile')
      .select('user_id,nickname').in('user_id', ids.slice(offset, offset + 200));
    if (error) throw error;
    for (const profile of data || []) names.set(profile.user_id, profile.nickname?.trim() || null);
  }
  return names;
}

export async function loadNicknamesByUsername(client, usernames) {
  const handles = [...new Set(usernames.filter(Boolean))];
  if (!handles.length) return new Map();
  const { data, error } = await client.from('auth_user').select('id,username').in('username', handles);
  if (error) throw error;
  const names = await loadProfileNicknames(client, (data || []).map((user) => user.id));
  return new Map((data || []).map((user) => [user.username, names.get(user.id) ?? null]));
}
